module.exports = __webpack_public_path__ + "7707e4c3ec1b0a2710bc163672225efd.png";